export const convertErrorsToOneString = (errors: string[]) => errors.join('\r\n');
